var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brands)?_c('div',[_c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions1}},_vm._l((_vm.brands),function(item,i){return _c('CardWithHover',{key:i,attrs:{"item":item}})}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }